var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEventSelfieWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "events",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_event_selfie_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "selfie"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.29,91.07v78.28A21.66,21.66,0,0,0,60.94,191H195.06a21.66,21.66,0,0,0,21.65-21.65V91.07a20.62,20.62,0,0,0-20.6-20.61H167.29l-.69-3A26.32,26.32,0,0,0,140.82,47H115.15A26.37,26.37,0,0,0,89.37,67.46l-.69,3H59.89A20.64,20.64,0,0,0,39.29,91.07ZM92.23,79.33a4.42,4.42,0,0,0,4.31-3.44L98,69.45a17.52,17.52,0,0,1,17.13-13.58h25.67a17.51,17.51,0,0,1,17.12,13.58l1.49,6.44a4.44,4.44,0,0,0,4.31,3.44h32.33A11.73,11.73,0,0,1,207.8,91.07v78.28A12.78,12.78,0,0,1,195,182.13H60.94a12.78,12.78,0,0,1-12.78-12.78V91.07A11.73,11.73,0,0,1,59.89,79.33Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 69.31,
    cy: 98.27,
    r: 5.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128,168.23A37.26,37.26,0,1,0,90.74,131,37.32,37.32,0,0,0,128,168.23Zm0-65.65A28.39,28.39,0,1,1,99.61,131,28.43,28.43,0,0,1,128,102.58Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEventSelfieWhite);
export default __webpack_public_path__ + "static/media/icon_event_selfie_white.09fbd125513d89fa015f2b05b3dc142b.svg";
export { ForwardRef as ReactComponent };